<template>
  <footer>
    <div>      
      <div>
        <img src="@/assets/images/logo.png" alt="">
        <h2>Titans House Experience</h2>
        <div class='schedule'>          
        </div>
      </div>
    </div>
  </footer>
</template>


<style lang="scss" scoped>
.schedule {
  text-transform: uppercase;  
  p {
    color:var(--dark-blue);    
  }
}
footer {
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
  color: var(--dark-blue);
  background:var(--white);
  padding: 30px;
  box-sizing: border-box;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1000px;
    margin: 0 auto;
    flex-direction: column;
    gap: 20px;            
    @media (min-width:400px) {
      flex-direction: row;      
      justify-content: center;
      max-width: 570px;
      margin:0 auto;
      gap:65px;
    }
  }  
  h2 {
    font-size: 1rem;
    margin: 0;
    margin-top:30px;
    text-transform: uppercase;    
    font-weight: 600;
  }
  p {
    margin: 0;
    color:var(--white);
  }
}
a {
  text-decoration: none;
  color:inherit;
}
</style>